import { createPinia } from 'pinia';
import { useUserStore } from './userJWTStore'; // Import the JWT user store

// Create and export the Pinia store instance
const pinia = createPinia();

// Initialize user store and load the JWT token
const userStore = useUserStore(pinia);
userStore.initializeStore(); // Ensuring the token is placed in the store when the app starts before the router is initialized
// This ensures that the user store is ready before any components or services use it

export default pinia;
